// extracted by mini-css-extract-plugin
module.exports = {"chatMember":"ChatMember_chatMember__33l8r","chatPersonStatus":"ChatMember_chatPersonStatus__2t3Kr","chatMemberLink":"ChatMember_chatMemberLink__3fBxd"};